import { Box, useTheme } from '@mui/material'
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar'
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat'
import FlightIcon from '@mui/icons-material/Flight'
import DirectionsRailwayIcon from '@mui/icons-material/DirectionsRailway'
import MultipleStopIcon from '@mui/icons-material/MultipleStop'
import { TransportModeId } from '../plannerTypes'

type TransportModeIconProps = {
  transportModeId?: number
}

const getTransportModeIcon = (transportModeId: number | undefined) => {
  switch (transportModeId) {
    case TransportModeId.Road:
      return <DirectionsCarIcon />
    case TransportModeId.Sea:
      return <DirectionsBoatIcon />
    case TransportModeId.Air:
      return <FlightIcon />
    case TransportModeId.Rail:
      return <DirectionsRailwayIcon />
    default:
      return <MultipleStopIcon />
  }
}

const TransportModeIcon = ({ transportModeId }: TransportModeIconProps) => {
  const theme = useTheme()
  return (
    <Box
      sx={{
        backgroundColor: 'white',
        color: theme.palette.primary.main,
        borderRadius: '50%',
        border: `2px solid ${theme.palette.primary.main}`,
        width: '40px',
        height: '40px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexShrink: 0,
      }}
    >
      {getTransportModeIcon(transportModeId)}
    </Box>
  )
}

export default TransportModeIcon
